import React from 'react';
import { useTranslation } from 'react-i18next';
import Img from '../../img/wc.png';
import './style.css';

const ContactDetails = () => {
  const { t } = useTranslation('contacts');

  return (
    <div className="contact-card">
      <h2 className="contact-card__title">{t('details.title')}</h2>
      <div className="contact-card__avatar">
        <img src={Img} alt="Customer support" width={128} height={128} className="contact-card__image" />
      </div>
      <p className="contact-card__role">{t('details.role')}</p>
      <a href="https://t.me/pixelcraft_fi" target="_blank" rel="noopener noreferrer" className="contact-card__link">
        {t('details.telegram')}
      </a>
      <a href="mailto:info@pixelcraft.fi" className="contact-card__link">info@pixelcraft.fi</a>
      <a href="tel:+358468130887" className="contact-card__link">+358 4681 308 87</a>
      <a href="https://wa.me/+358468130887" target="_blank" rel="noopener noreferrer" className="contact-card__link">
        {t('details.whatsapp')}
      </a>
      <p className="contact-card__text">{t('details.consultText')}</p>
      <a href="/contacts" className="button">{t('common:buttons.bookConsultation')}</a>
    </div>
  );
};

export default ContactDetails;
